import classNames from "classnames";
import React from "react";

import { IFormSubmitButton } from "../models/formFields.interfaces";
import { AbstractFormComponent } from "./AbstractFormComponent";

// TODO(ssr, LEVEL 3 out of 10): Migrate to functional component
// Complexity: Simple submit button component with generic type parameter. Overrides buildContent()
// and render() methods. Has defaultProps and getInputProps() helper. No state or lifecycle methods.
// Migration: Convert to functional component with default props via destructuring. Replace
// getInputProps() with inline props object. Use FormFieldWrapper (from migrated AbstractFormComponent)
// for error display. The generic type parameter can be maintained in functional component signature.
// Straightforward migration once AbstractFormComponent is migrated.
export class FormSubmit<
    FieldName extends string = string,
> extends AbstractFormComponent<
    IFormSubmitButton<FieldName>,
    Record<string, never>
> {
    public static defaultProps = {
        hidden: false,
        type: "submit",
        value: "Submit",
        className: "button button--primary-congress-blue",
    };

    protected getInputProps() {
        return {
            id: this.props.id,
            ref: this.props.inputRef,
            name: this.props.name,
            type: this.props.type,
            className: this.props.className,
            value: this.props.value === null ? "" : this.props.value,
            disabled: this.props.disabled,
            onMouseEnter: this.props.onMouseEnter,
            onMouseLeave: this.props.onMouseLeave,
            onSubmit: this.props.onSubmit,
        };
    }

    protected buildContent(): React.JSX.Element {
        const props = this.getInputProps();
        return <input {...props} />;
    }

    public render(): React.JSX.Element {
        const classes = classNames({
            "form__field": true,
            "form__field--submit": true,
            "form__field--hidden": this.props.hidden,
            "form__field--has-errors": this.showValidationErrors(),
        });
        return <div className={classes}>{this.buildContent()}</div>;
    }
}
